import { AcknowledgementRequestStatus } from 'utils/api/modules/entities/entities.types';

export const ACK_REQUEST_STATUS_LABELS: Record<AcknowledgementRequestStatus, string> = {
  [AcknowledgementRequestStatus.Active]: 'Active',
  [AcknowledgementRequestStatus.Completed]: 'Completed',
  [AcknowledgementRequestStatus.Cancelled]: 'Cancelled',
};
